export enum EntitiesType {
    FIREARMS = 'firearms',
    DRUGS = 'drugs',
    OTHER_ITEMS = 'otherItems',
}

export type EditableFirearmFormProperty = 'firearms' | 'mergedFirearms';
export type EditableDrugsFormProperty = 'drugs' | 'mergedDrugs';
export type EditableOtherItemsFormProperty = 'otherItems' | 'mergedOtherItems';
